<template>
  <div class="search-frame">
    <Selector class="v-selector" @selectElement="updateLocation" :init_selected="search.location" :init_elements="locations"  :placeholder="'Нас. пункт'"/>
    <Selector class="v-selector" @selectElement="updateCategory" :init_selected="search.category" :init_elements="categories" :placeholder="'Категория'"/>
    <Selector class="v-selector" v-if="showRooms" @selectElement="updateRooms" :init_selected="search.rooms" :init_elements="flat_rooms" :placeholder="'Комнат'"/>
    <Selector class="v-selector" v-if="search.category === 'houses'" @selectElement="updateHouseType" :init_selected="search.house_type" :init_elements="house_types" :placeholder="'Тип'"/>
    <Selector class="v-selector" v-if="search.category === 'lots'" @selectElement="updateLotType" :init_selected="search.lot_type" :init_elements="lot_types" :placeholder="'Назначение'"/>
    <Selector class="v-selector" v-if="search.category === 'commercial'" @selectElement="updateCommercialType" :init_selected="search.commercial_type" :init_elements="commercial_types" :placeholder="'Тип'"/>
    <RangeSelector class="v-range-selector" key="area_select" v-if="showArea" :strategy="'area'" :init_from="search.s_from.toString()"  :init_to="search.s_to.toString()" @selectRange="updateArea"/>
    <RangeSelector class="v-range-selector" key="lot_area_select" v-if="showLotArea" :strategy="'lot_area'" :init_from="search.lot_from.toString()" :init_to="search.lot_to.toString()" @selectRange="updateLotArea"/>
    <RangeSelector class="v-range-selector price-selector" key="price_select" :strategy="'price'" :init_from="search.price_from.toString()"  :init_to="search.price_to.toString()" @selectRange="updatePrice"/>

    <div class="search-btn-wrapper"><span class="srch" @click="goSearch">Найти</span></div>
  </div>
</template>

<script>
  import Selector from "./selector.vue";
  import RangeSelector from "./range_selector.vue";
  export default  {
    name: 'Search',
    props:[],
    components: {RangeSelector, Selector},
    data: function () {
      return {
        search: {
          category:'',
          rooms:'',
          house_rooms:'',
          s_from: '',
          s_to: '',
          lot_from: '',
          lot_to: '',
          price_from: '',
          price_to: '',
          location: '',
          house_type: '',
          commercial_type: '',
          lot_type: ''
        },
        categories: [{slug:'flats',title:'Квартиры'},{slug:'new_flats',title:'Новостройки'},{slug:'houses',title:'Дома'},{slug:'lots',title:'Участки'},{slug:'commercial',title:'Коммерческая'},{slug:'garages',title:'Гаражи'}],
        flat_rooms: [{slug:'0',title:'Студии'},{slug:'1',title:'1-комнатные'},{slug:'2',title:'2-комнатные'},{slug:'3',title:'3-комнатные'},{slug:'3+',title:'3+ комнат'}],
        house_rooms: [{slug:'1',title:'1-комнатные'},{slug:'2',title:'2-комнатные'},{slug:'3',title:'3-комнатные'},{slug:'4',title:'4-комнатные'},{slug:'4+',title:'4+ комнат'}],
        house_types: [{slug:'house',title:'Дом'},{slug:'townhouse',title:'Таунхаус'},{slug:'duplex',title:'Дуплекс'},{slug:'house_part',title:'Часть дома'}],
        lot_types: [{slug:'live',title:'ИЖС'},{slug:'dacha',title:'Дачные'},{slug:'sh',title:'Сельхоз'}],
        commercial_types: [{slug:'office',title:'Офисы'},{slug:'free',title:'Помещения'},{slug:'trade',title:'Торговля'},{slug:'business',title:'Бизнес'},{slug:'hotels',title:'Гостиницы'}],
        locations: [{title:"Анапа",slug:"Анапа"},{title:"Анапская",slug:"Анапская"},{title:"Благовещенская",slug:"Благовещенская"},{title:"Большой Утриш",slug:"Большой Утриш"},{title:"Бужор",slug:"Бужор"},{title:"Варваровка",slug:"Варваровка"},{title:"Варениковская",slug:"Варениковская"},{title:"Верхнее Джемете",slug:"Верхнее Джемете"},{title:"Веселовка",slug:"Веселовка"},{title:"Вестник",slug:"Вестник"},{title:"Ветеран (с Супсех)",slug:"Ветеран (с Супсех)"},{title:"Виктория (х Красный)",slug:"Виктория (х Красный)"},{title:"Виноградный",slug:"Виноградный"},{title:"Витязево",slug:"Витязево"},{title:"Воскресенский",slug:"Воскресенский"},{title:"Гай-Кодзор",slug:"Гай-Кодзор"},{title:"Голубицкая",slug:"Голубицкая"},{title:"Горный (с Сукко)",slug:"Горный (с Сукко)"},{title:"Гостагаевская",slug:"Гостагаевская"},{title:"Джигинка",slug:"Джигинка"},{title:"Закубанский",slug:"Закубанский"},{title:"Заря",slug:"Заря"},{title:"Здоровье (хутор Куток)",slug:"Здоровье (хутор Куток)"},{title:"Зеленая Роща (село Сукко)",slug:"Зеленая Роща (село Сукко)"},{title:"Иванов",slug:"Иванов"},{title:"Капустин",slug:"Капустин"},{title:"Колос (х Куток)",slug:"Колос (х Куток)"},{title:"Красная Горка",slug:"Красная Горка"},{title:"Красная Скала",slug:"Красная Скала"},{title:"Красный",slug:"Красный"},{title:"Красный Курган",slug:"Красный Курган"},{title:"Кубань (с Цибанобалка)",slug:"Кубань (с Цибанобалка)"},{title:"Куматырь",slug:"Куматырь"},{title:"Курбацкий",slug:"Курбацкий"},{title:"Куток",slug:"Куток"},{title:"Малый Утриш",slug:"Малый Утриш"},{title:"Мечта (с Супсех)",slug:"Мечта (с Супсех)"},{title:"Морское (п Пятихатки)",slug:"Морское (п Пятихатки)"},{title:"Надежда (ст-ца Гостагаевская)",slug:"Надежда (ст-ца Гостагаевская)"},{title:"Натухаевская",slug:"Натухаевская"},{title:"Нижняя Гостагайка",slug:"Нижняя Гостагайка"},{title:"Персик",slug:"Персик"},{title:"Персик (с Супсех)",slug:"Персик (с Супсех)"},{title:"Персик (село Супсех)",slug:"Персик (село Супсех)"},{title:"Песчаный",slug:"Песчаный"},{title:"Пищевик (х Куток)",slug:"Пищевик (х Куток)"},{title:"Приморский",slug:"Приморский"},{title:"Просторный",slug:"Просторный"},{title:"Пятихатки",slug:"Пятихатки"},{title:"Рассвет",slug:"Рассвет"},{title:"Сенной",slug:"Сенной"},{title:"Строитель (х Красная Скала)",slug:"Строитель (х Красная Скала)"},{title:"Строитель (хутор Красная Скала)",slug:"Строитель (хутор Красная Скала)"},{title:"Сукко",slug:"Сукко"},{title:"Супсех",slug:"Супсех"},{title:"Тарусин",slug:"Тарусин"},{title:"Усатова Балка",slug:"Усатова Балка"},{title:"Уташ",slug:"Уташ"},{title:"Цибанобалка",slug:"Цибанобалка"},{title:"Чекон",slug:"Чекон"},{title:"Чембурка",slug:"Чембурка"},{title:"Черемушка (хутор Куток)",slug:"Черемушка (хутор Куток)"},{title:"Южное (х Красный)",slug:"Южное (х Красный)"},{title:"Юровка",slug:"Юровка"}]
      }
    },
    mounted() {
      if (window.gon !== undefined && gon.search !== undefined) {
        // this.search.location = gon.search.location;
        this.search = gon.search;
        // this.search.price_from = '2500000';
      }
    },
    methods: {
      updateCommercialType(data) {
        this.search.commercial_type = data.slug;
      },
      updateLotType(data) {
        this.search.lot_type = data.slug;
      },
      updateHouseType(data) {
        this.search.house_type = data.slug;
      },
      updateLocation(data) {
        this.search.location = data.slug;
      },
      updateLotArea(data) {
        this.search.lot_from = data.from;
        this.search.lot_to = data.to;
      },
      updateArea(data) {
        this.search.s_from = data.from;
        this.search.s_to = data.to;
      },
      updatePrice(data) {
        this.search.price_from = data.from;
        this.search.price_to = data.to;
      },
      updateCategory(data) {
        this.search.category = data.slug
      },
      updateHouseRooms(data) {
        this.search.house_rooms = data.slug
      },
      updateRooms(data) {
        this.search.rooms = data.slug
      },
      goSearch() {
        window.location.href = `/search?${this.urlParams}`;
      }
    },
    computed: {
      showRooms() {
        return ['flats','new_flats'].includes(this.search.category)
      },
      showHouseRooms() {
        return ['houses'].includes(this.search.category)
      },
      showArea() {
        return this.search.category !== 'lots'
      },
      showLotArea() {
        // return ['lots','houses'].includes(this.search.category)
        return this.search.category === 'lots'
      },
      urlParams() {
        return Object
            .keys(this.search)
            .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(this.search[k])}`)
            .join('&');
      }
    }
  }
</script>

<style scoped lang="scss">
  .search-frame {
    padding: 30px 50px;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 5px;
    display: inline-flex;
    align-self: flex-start;
    margin: 0 auto;
  }

  h3 {
    text-transform: uppercase;
    font-weight: 600;
    color: #1D72B3;
  }

  .srch {
    display: flex;
    border-radius: 5px;
    background-color: #1D72B3;
    color: white;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    margin-left: 10px;
    cursor: pointer;
    height: 50px;
    &:hover {
      background-color: #19649b;
    }
  }

  .mobile-search {
    .search-frame {
      padding: 10px;
      display: flex;
      flex-wrap: wrap;
    }
    .search-btn-wrapper {
      width: 100%;
      padding-top: 20px;
      display: flex;
      justify-content: center;
      .srch {
        height: 40px;
        width: 150px;
      }
    }
  }

  .top-search {
    .search-frame {
      margin-top: 20px;
      background-color: #F5F5F5;
    }
  }


</style>